import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Row, Col } from "react-flexbox-grid";
import Button from "@material-ui/core/Button";
import _ from "lodash";

class LoginButton extends Component {
  render() {
    const isAuthenticated = !_.isNil(localStorage.getItem("token"));
    if (isAuthenticated) {
      return (
        <Row>
          <Col xs={12} md={4}>
            <Button color="inherit" component={Link} to="/">
              Inicio
            </Button>
          </Col>
          <Col xs={12} md={4}>
            <Button color="inherit" component={Link} to="/admin/index">
              Admin
            </Button>
          </Col>
          <Col xs={12} md={4}>
            <Button
              color="inherit"
              component={Link}
              to="/login"
              onClick={() => {
                localStorage.removeItem("token");
              }}
            >
              Salir
            </Button>
          </Col>
        </Row>
      );
    }
    return (
      <React.Fragment>
        <Button color="inherit" component={Link} to="/">
          Inicio
        </Button>
        <Button color="inherit" component={Link} to="/login">
          Ingresar
        </Button>
      </React.Fragment>
    );
  }
}

export default LoginButton;



// WEBPACK FOOTER //
// ./src/components/login/login-button.js